import styled from '@emotion/styled';

export const InputWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  font-family: Noto Sans KR;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #555555;
`;

export interface StyledInputProps {
  textAlign?: 'left' | 'center' | 'right';
}

export const StyledInput = styled.input<StyledInputProps>`
  box-sizing: border-box;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  color: #555;
  width: 100%;
  height: 24px;
  font-family: Noto Sans KR;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  padding-left: 16px;
  padding-right: 16px;
  text-align: ${(props) => props.textAlign};

  &:focus,
  &:focus:hover {
    outline: none;
    border-color: #00bf00 !important;
  }

  &:read-only {
    outline: none;
    border: none;
    font-size: 14px;
    cursor: default;
    color: #555555;

    & + span {
      display: block;
    }
  }

  &:hover {
    border-color: #777;
  }

  &[value='']:read-only::placeholder {
    color: transparent;
  }

  &::placeholder {
    color: #ccc;
  }
`;

/**
 * input에 user-select: none 이 먹히지 않으므로 span 으로 대체
 */
export const UnUserSelect = styled.span`
  position: absolute;
  left: 0;
  top: 0;
  display: none;
  width: 100%;
  height: 100%;
  user-select: none;
`;
